<template>
    <div>
      <button
        style="display: none"
        type="button"
        class="btn-confirm-modal-drag-move-item"
        data-bs-toggle="modal"
        data-bs-target="#ModalConfirmDragMoveItem"
      ></button>
      <div
        class="modal fade"
        id="ModalConfirmDragMoveItem"
        tabindex="-1"
        aria-labelledby="modalConfirmDeleteLabel"
        aria-hidden="true"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
      >
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-body">{{ message }}</div>
            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-success btn-background btn-sm"
                @click="processYes"
              >
                Keep
              </button>
              <button
                type="button"
                class="btn btn-primary btn-close-modal btn-sm"
                data-bs-dismiss="modal"
                @click="processNo"
              >
                Discard
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: "ExchangeStatus",
    props: {
      id: {
        type: String,
        required: true,
      },
      message: {
        type: String,
        default: "",
      },
      btnYes: {
        type: String,
        default: "",
      },
      processNo: {
        type: Function,
        default: () => {},
      },
      processYes: {
        type: Function,
        default: () => {},
      },
    },
  };
  </script>